import React, { useState } from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Portfolio } from './components/Portfolio';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './components/PrivacyPolicy';
export function App() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-cyan-400/30 selection:text-cyan-200" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <Portfolio data-id="element-5" />
          <About data-id="element-6" />
          <Contact data-id="element-7" />
        </main>
        <Footer onPrivacyClick={() => setIsPrivacyOpen(true)} data-id="element-8" />
        <PrivacyPolicy isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-9" />
      </div>
    </LanguageProvider>;
}